<template>
<div>

<div v-if="type=='A'">

<spinner v-bind:spinner='spinner'></spinner> 



<h4 style="color:black" > RICERCA ORDINI </h4>

<supplier-select @update="setSupplierId" v-bind:isActive="true"></supplier-select>
 <button :disabled="spinner" @click="getData()" type="button"  class="btn btn-primary mb-2">
    <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
   CERCA
        <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button> 
<alert-box class="mt-2 mb-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
<h4 style="color:navy" > <strong>LISTA ORDINI</strong> </h4>
<div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-hover _table-striped table-sm mb-0">
    <thead class="table-primary" >
      <tr>
        <th scope="col"></th>
        <th scope="col">#</th>

        <th scope="col">FORNITORE</th>
        
        
        <th scope="col">SEDE</th>
        <th scope="col">NUMERO</th>
        <th scope="col">DATA</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">ANNO</th>
        <th scope="col">REGISTRATO</th>
        <th scope="col">AGGIORNATO</th>
       
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="" class="pointer" v-on:dblclick="setOrder(item)" v-for="(item, index) in filteredOrders" :key="index">
        
        <td >
          <a class="ml-3" @click="editHeader(item)"><i style='color:brown' data-toggle="tooltip" title="Modifica intestazione"  :class="edit == true ? 'fa fa-edit':''" aria-hidden="true"></i></a>    
        </td>
        
        <td>{{index+1}}</td> 
        <td>{{item.supplier}}</td>
        <!--
        <td>{{item.orderId}}</td>
        -->
        
        <td>{{item.store}}</td>
        <td>{{item.order_num}}</td>
        <td>{{item.order_date}}</td>
        
        <td>{{item.season}}</td>
        <td>{{item.season_year}} </td>
        <td >{{item.create_at}} </td>
        <td >{{item.update_at}} </td>
        
        
       
      </tr> 
    </tbody>
  </table>

</div>
<filter-key @update="setFilterKey"/>  



</div>
<div v-else>


    <edit-order-header  v-bind:_order="item" v-bind:type="'B'" ></edit-order-header>
    <button @click="type='A'" type="button"  class="btn btn-secondary mt-1 ml-2">
    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
      RITORNA A LISTA ORDINI        
    </button> 

</div>  




</div>


</template>
<script>
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import spinner           from '@/components/common/Spinner.vue';
import supplierSelect    from '@/components/common/SupplierSelect.vue';
import editOrderHeader   from '@/components/order/OrderHeader.vue';
import api               from '@/api'
import filterKey         from '@/components/common/FilterKey.vue'




export default {
  
  components  : {alertBox,spinner,supplierSelect,filterKey,editOrderHeader},
  props : ['edit'],
  data() {
    return {
    supplierId      : 0,
   
    items           : [],
      
      msg             : {
        title : '',
        body  : '',
        type  : 0      
      },
      alert           : false,
      spinner         : false,
      filterKey       : '',
      type            : 'A',
      item            : {}
      
    };
  },
  computed :{ 
    ...mapGetters(['company']),   
      filteredOrders : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
  mounted: function() {},
  created: function() {

    //this.getData()
  },  
  methods: {


    editHeader(item)
    {

      if(this.edit)
      {
        console.log('EDIT',item)
        this.item = item
        this.type = 'B'
      }
      
    },
    setFilterKey(value)
    {this.filterKey =  value
    },
     fmt1(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },  
   
    setSupplierId(supplierId)
    {
        this.supplierId = supplierId
    },

    setOrder(item)
    {  
     
      this.$emit('update',item)
      
    },
   
    



    async getData()
    {
        this.msg.title = ''
        this.items   = []
        this.spinner = true
        
        var sp    = {'sp'         :'spSupplierOrders'}
        var data  = {'supplierId' : this.supplierId,'companyId':this.company.Id}
        var json  = Object.assign(data, sp);
        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]
              
              if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = 'ORDINI FORNITORE INESISTENTI.'  
                this.msg.type = 1         
               }
            }
            else if(res.status==500)
            {
             
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res.data 
                this.msg.type = 1         

            } 
            else
            {
             
                this.msg.title = 'ATTENZIONE '  
                this.msg.body = res
                this.msg.type = 1                         
            } 
        }).catch(err => 
        {
          
            this.msg.title = 'ATTENZIONE '  
            this.msg.body = err.message
            this.msg.type = 1             
        }).finally(() => {
          this.spinner = false
        });



     



    },

    
    
    
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.pointer:hover
{
  _background-color : azure;
  _color            :black;
  cursor           : pointer;
}
.table-wrapper-scroll-y {
display: block;
}

h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 20px;
}

.table th:first-child
{
  border-radius : 0 0 0 10px;
}

.table th:last-child
{
  border-radius : 0 10px 0 0;  
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
</style>